import type { Member, Settings } from '../types'

export type AttendanceStatus = 'zelena' | 'oranzna' | 'rdeca' | 'premalo'

export interface AttendanceSummary {
  status: AttendanceStatus
  odstotek: number | null
  prisoten: number
  pricakovan: number
}

export function attendanceSummary(m: Member, s: Settings): AttendanceSummary {
  const odstotek = m.pricakovan > 0 ? Math.round((m.prisoten / m.pricakovan) * 100) : null
  if (m.pricakovan < s.minDogodkov || odstotek === null) {
    return { status: 'premalo', odstotek, prisoten: m.prisoten, pricakovan: m.pricakovan }
  }
  const status: AttendanceStatus =
    odstotek >= s.pragZelena ? 'zelena' : odstotek >= s.pragOranzna ? 'oranzna' : 'rdeca'
  return { status, odstotek, prisoten: m.prisoten, pricakovan: m.pricakovan }
}

export const statusLabel: Record<AttendanceStatus, string> = {
  zelena: 'V redu',
  oranzna: 'Na meji',
  rdeca: 'Pod pragom',
  premalo: 'Premalo podatkov',
}

export const statusClass: Record<AttendanceStatus, string> = {
  zelena: 'bg-green-50 text-green-700 border-green-200',
  oranzna: 'bg-amber-50 text-amber-800 border-amber-200',
  rdeca: 'bg-rose-50 text-rose-700 border-rose-200',
  premalo: 'bg-slate-100 text-ink-muted border-line',
}

export const statusDot: Record<AttendanceStatus, string> = {
  zelena: 'bg-green-500',
  oranzna: 'bg-amber-500',
  rdeca: 'bg-rose-500',
  premalo: 'bg-slate-300',
}

export const statusBar: Record<AttendanceStatus, string> = {
  zelena: 'bg-green-500',
  oranzna: 'bg-amber-500',
  rdeca: 'bg-rose-500',
  premalo: 'bg-slate-300',
}
